import React from 'react'
import { DescriptionBox, TextBox, Icon } from './DescriptionStyled'
import { WithIconProps } from './interfaces'

export default function WithIcon({
  icon,
  title,
  description,
  width,
  height,
  background,
  textColor,
  borderColor,
  size,
}: WithIconProps) {
  return (
    <DescriptionBox>
      <Icon
        width={width || '42px'}
        height={height || '42px'}
        background={background || 'rgba(255, 176, 0, 1)'}
        textColor={textColor}
        borderColor={borderColor}
        size={size || '16px'}
      >
        {icon}
      </Icon>
      <TextBox>
        <h4>{title}</h4>
        <p>{description}.</p>
      </TextBox>
    </DescriptionBox>
  )
}
